<template>
    <div v-if="bill">
        <!-- <div class="vx-row justify-between">
            <div class="w-4/12 ml-8">
                <vs-button type="relief" > <a-icon type="check"/> FINALIZAR PEDIDO </vs-button>
            </div>

            <div class="w-4/12 text-right mr-8">
                <vs-button type="border" > CANCELAR PEDIDO </vs-button>
            </div>
        </div> -->
        <div class="vx-row justify-between" style="position: relative; top: 6px">
            <div class="w-7/12 pl-8">
                <div class="vx-row ml-2">
                    <btn-transfer-delivery-to-table :billId="selectedId" />
                    <h3 class="text-danger font-bold" style="text-decoration: underline">  {{ $t('order').toUpperCase() }}: {{ String(bill.startingFrom).padStart('2', '0') }}</h3>
                </div>
            </div>

            <div class="w-4/12 text-right mr-8">
                <h4 class="text-grey"> {{ bill.openedOn.toDate() | moment('DD/MM/YYYY HH:mm') }} </h4>
            </div>
        </div>

        <vs-divider border-style="dashed" />

        <div class="vx-row pl-8">           
            <span class="w-full"> <strong>{{ $t('customer').toUpperCase() }}:</strong> {{ Object.entries(bill.usersOrders)[0][1].userName }} </span>
            <span class="w-full mt-1"> <strong>{{ $t('phone').toUpperCase() }}:</strong> {{ bill.deliveryData.payment.phoneNumber }} </span>
            <span class="w-full mt-1" v-if="bill.deliveryData.toDeliver"> 
                <strong>{{ $t('address').toUpperCase() }}:</strong>
                {{ bill.deliveryData.addressData.street }}, {{ bill.deliveryData.addressData.number }}, {{ bill.deliveryData.addressData.neighborhood }},
                {{ bill.deliveryData.addressData.city }} - CEP: {{ bill.deliveryData.addressData.cep }}
            </span>
            <span class="w-full mt-1" v-if="bill.deliveryData.toDeliver"> <strong>{{ $t('complement').toUpperCase() }}:</strong> {{ bill.deliveryData.addressData.complement }} </span>
            <span class="w-full mt-1"> <strong>{{ $t('observation').toUpperCase() }}:</strong> {{ bill.deliveryData.payment.obs }} </span>
            <h5 class="w-full mt-4 text-primary"> {{ bill.deliveryData.toDeliver ? $t('toDeliver').toUpperCase() : $t('takeAndGo').toUpperCase() }} </h5>
        </div>

        <vs-divider border-style="dashed" />

        <div class="vx-row pl-8 justify-between">           
            <span class="sm:w-full md:w-full lg:w-4/12 xl:w-3/12 w-full mt-2 pl-4" v-if="bill.deliveryData.toDeliver "> 
                <div class="vx-row">
                    <strong> {{ $t('paymentMethod').toUpperCase() }}: </strong> 
                </div>
                <div class="vx-row">
                    {{ $t(bill.deliveryData.payment.paymentType.toLowerCase()).toUpperCase() }}
                </div>
            </span>
            <span class="sm:w-full md:w-full lg:w-4/12 xl:w-3/12 w-full mt-2 pl-4" style="text-decoration: underline" v-if="bill.deliveryData.toDeliver ">
                <div class="vx-row">
                    <strong>{{ $t('changeFor').toUpperCase() }}:</strong>
                </div>
                <div class="vx-row">
                    {{ bill.deliveryData.payment.changeFor ? String(bill.deliveryData.payment.changeFor).replace(',','.') : 0 | currency }}
                </div>
                
            </span>
                
            <h5 class="sm:w-full md:w-full lg:w-4/12 xl:w-3/12 mt-2 text-danger text-1xl pl-4"> 
                <div class="vx-row">
                    <strong>{{ $t('totalToPay').toUpperCase() }}:</strong> 
                </div>
                <div class="vx-row">
                    {{ bill.value ? String(bill.value).replace(',','.') : 0 | currency }} 
                </div>
            </h5>
        </div>

        <vs-divider border-style="dashed" />

        <div class="vx-row pl-8">       
                
            <span class="w-full text-xl"> <strong>{{ $t('products').toUpperCase() }}:</strong> </span>
            <div class="vx-row w-full ml-1" v-for="(order, i) in Object.entries(bill.usersOrders)[0][1].orders" :key="i">
                <order-item :order="order">
                    <vs-icon 
                        icon-pack="material-icons" 
                        icon="delete_outline" 
                        class="text-danger cursor-pointer" 
                        style="font-size: 28px;"
                         @click="removeOrderFromUserBill(selectedId, Object.entries(bill.usersOrders)[0][1], order.id)"  
                        slot="actions" />
                    <!-- <a-button slot="actions"
                        type="danger" 
                        shape="circle" 
                        icon="delete" 
                        class="text-white" 
                        @click="removeOrderFromUserBill(selectedId, Object.entries(bill.usersOrders)[0][1], order.id)" /> -->
                </order-item>
            </div>
        </div>
    </div>
</template>

<script>
    import { httpsCallable } from "@/firebase/functions";
    import BtnTransferDeliveryToTable from './btnTransferDeliveryToTable'
    import OrderItem from './OrderItem';

    export default {
        components: {
            BtnTransferDeliveryToTable,
            OrderItem
        },
        props : {
            data : {
                type : Array,
                required : true
            },

            selectedId : {
                type : String,
                required : true
            }
        },

        data () {
            return {
                bill : ''
            }
        },

        watch : {
            data () {
                this.selectBill()
            },

            selectedId () {
                this.selectBill()
            }
        },

        methods : {
            selectBill () {
                this.bill = (this.data.filter(a => a.id == this.selectedId) || [])[0]
            },

            removeOrderFromUserBill (billId, userId, orderId) {
                let companyId = this.$store.getters.getCompanyID
                let that = this;

                this.$confirm({
                    zIndex: 9999998,
                    title: 'Confirme a sua intenção!',
                    content: 'Deseja realmente remover este produto da comanda?',
                    okText : 'Sim!',
                    cancelText: 'Não!',
                    okType : 'danger',
                    async onOk() {
                        try {
                            that.$vs.loading();

                            let call = httpsCallable('removeItemInBill')
                            let removeItem = await call({ companyId : companyId, billId : billId, orderId : orderId })
                        } catch (err) {
                            that.$error({
                                zIndex : 9999999,
                                title: 'Erro!',
                                content: `ao tentar remover produto da comanda: ${err.message}`
                            })
                        } finally {
                            that.$vs.loading.close()
                        }
                        
                    }
                })
            },
        }
    }
</script>